























import { deleteProjectPropertyKey } from "@/api/project/project-properties-api";
import { Component, Prop, Vue } from "vue-property-decorator";

export interface ProjectPropertyKeyItem {
  id: string;
  name: string;
}

/**
 * 現場のプロパティキーのテーブル
 */
@Component({})
export default class ProjectPropertyKeyTable extends Vue {
  @Prop({ required: true }) items!: ProjectPropertyKeyItem[];

  fields = [{ key: "name", label: "キー名" }, { key: "actions", label: "" }];

  async deleteItem(id: string) {
    if (!confirm("この項目を削除してもよろしいですか？")) {
      return;
    }
    await deleteProjectPropertyKey(id);
    this.$emit("remove", id);
  }
}
